import { Injectable } from "@angular/core";
// import Web3Modal from "web3modal-fixed";
import { forkJoin, from, Observable, Observer, of, switchMap } from "rxjs";
// import WalletConnectProvider from "@walletconnect/web3-provider";
// import WalletConnectProvider, { EthereumProvider } from '@walletconnect/ethereum-provider';
import { WalletConnectModal } from "@walletconnect/modal";
import { bsc, bscTestnet } from '@wagmi/core/chains'
const projectId = 'dd7646c2f0032eaeeaf0540f0ccbb92d'
import { WalletConnectModalSign } from "@walletconnect/modal-sign-html";
import { WalletConnectModalAuth } from "@walletconnect/modal-auth-html";
import { disconnect } from '@wagmi/core'


@Injectable({
    providedIn: 'root'
})
export class MetamaskWrapperService {


    connect(): Observable<any> {
        // wagmiConnector.disconnect().then(d=>{
        //     console.log('disconnect',d)
        // });
        // return from(wagmiConnector.connect());


        defaultModalTest.openModal()
        return new Observable((observer: Observer<any>) => {
            observer.next(defaultModalTest)
            observer.complete();
        })

        return of(true);
        return from(web3Modal.connect({
            requiredNamespaces: {
                eip155: {
                    methods: ["eth_sendTransaction", "personal_sign"],
                    chains: ["eip155:1"],
                    events: ["chainChanged", "accountsChanged"],
                },
            },
        }));
        // return from(modalAuth.signIn({ statement: "Sign In to My Dapp" }));
    }


    disconnectProvider(): Observable<any> {
        // return of(web3Modal2.clearCachedProvider());
        return from(disconnect());
    }


}


// const modal = new WalletConnectModal({
//     projectId: 'dd7646c2f0032eaeeaf0540f0ccbb92d',
//     chains: ['eip155:1'],

// })

const chains = [/* bsc,  */bscTestnet]

const web3Modal = new WalletConnectModalSign({
    projectId,
    metadata: {
        name: "My Dapp",
        description: "My Dapp description",
        url: "https://my-dapp.com",
        icons: ["https://my-dapp.com/logo.png"],
    },
    modalOptions: {
        mobileWallets: [
            {
                id: 'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
                name: 'Metamask',
                links: {
                    native: 'https://metamask.io/',
                    universal: 'https://metamask.io/'
                }
            }
        ],
        explorerRecommendedWalletIds: [
            'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
            '1ae92b26df02f0abca6304df07debccd18262fdf5fe82daa81593582dac9a369',
            '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0'
        ]
    }
});

const modalAuth = new WalletConnectModalAuth({
    projectId,
    metadata: {
        name: "My Dapp",
        description: "My Dapp description",
        url: "https://my-dapp.com",
        icons: ["https://my-dapp.com/logo.png"],
    },
});


// const modalDefailt = new Web3Modal({
//     projectId,

// });
// import { configureChains, createConfig } from "@wagmi/core";
// import {
//     EthereumClient,
//     w3mConnectors,
//     w3mProvider,
// } from "@web3modal/ethereum";
// import { Web3Modal } from "@web3modal/html";

// const { publicClient } = configureChains(chains, [w3mProvider({ projectId })]);
// const wagmiConfig = createConfig({
//     autoConnect: true,
//     connectors: w3mConnectors({ chains, projectId }),
//     publicClient,
// });
// const ethereumClient = new EthereumClient(wagmiConfig, chains);

// export const web3ModalDefault = new Web3Modal(
//     {
//         projectId,
//         walletImages: {
//             safe: "https://pbs.twimg.com/profile_images/1566773491764023297/IvmCdGnM_400x400.jpg",
//         },
//     },
//     ethereumClient
// );
import { EthereumClient, w3mConnectors, w3mProvider } from '@web3modal/ethereum'
import { Web3Modal } from '@web3modal/html'
import { configureChains, createConfig } from '@wagmi/core';
import { getPublicClient, getContract } from '@wagmi/core'
import { usePublicClient } from "wagmi";




const { publicClient } = configureChains(chains, [w3mProvider({ projectId })])
const wagmiConfig = createConfig({
    autoConnect: true,
    connectors: w3mConnectors({ projectId, chains }),
    publicClient
})
const ethereumClient = new EthereumClient(wagmiConfig, chains)
const defaultModalTest = new Web3Modal(
    {
        projectId,
        themeVariables: { '--w3m-z-index': '1100' },
        mobileWallets: [{
            id: 'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
            name: 'Metamask',
            links: {
                native: 'https://metamask.io/',
                universal: 'https://metamask.io/'
            }
        }]
    },

    ethereumClient)

const walletConnectModal = new WalletConnectModal({
    projectId: projectId,
    chains: ['eip155:1'],

})


export const getProviderOption = (): any => {
    return {
        projectId: projectId,
        chains: [/* 56 */97], // REQUIRED chain ids
        // optionalChains, // OPTIONAL chains
        showQrModal: false, // REQUIRED set to "true" to use @walletconnect/modal
        // methods, // REQUIRED ethereum methods
        // optionalMethods, // OPTIONAL ethereum methods
        // events, // REQUIRED ethereum events
        // optionalEvents, // OPTIONAL ethereum events
        rpcMap: {
            // 56: "https://bsc-dataseed.binance.org",
            97: "https://data-seed-prebsc-1-s1.binance.org:8545/"
        },
        metadata: {
            name: "My Dapp QR",
            description: "My Dapp description",
            url: "https://my-dapp.com",
            icons: ["https://my-dapp.com/logo.png"],
        },
    }
}




import { WalletConnectConnector } from '@wagmi/core/connectors/walletConnect'

const wagmiConnector = new WalletConnectConnector({
    chains: [bsc, bscTestnet],
    options: {
        projectId: projectId,
        metadata: {
            name: 'wagmi',
            description: 'my wagmi app',
            url: 'https://wagmi.sh',
            icons: ['https://wagmi.sh/icon.png'],
        },
    }
})